import axios from "axios";
import sessionHelper from "./sessionHelper";
import routesMap from "@/helpers/routesMap";
// const siteUrl = 'http://shepa.ca-language.com/api/';
//const siteUrl = 'https://test.shepa.com/api/';//process.env.siteUrl;//
const siteUrl = routesMap.api;
const siteUrl_wapi = routesMap.base;

//const siteUrl = 'http://127.0.0.1:8001/api/';
let onlineTime = 1801;
class HttpHelper {
  config = {
    baseURL: siteUrl,
    timeout: 180000,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  getOnlineTime() {
    return onlineTime;
  }
  setOnlineTime(value) {
    // if (onlineTime > value) {
    //     return;
    // }
    onlineTime = value;
  }
  constructor() {}
  getData(url) {
    this.setOnlineTime(1801);
    url = url;
    if(url.startsWith("~strategy")){
      url = url.replace("~strategy", "");
      this.config.baseURL = routesMap.strategyApi;
    } else if(url.startsWith("~transfer")){
      url = url.replace("~transfer", "");
      this.config.baseURL = routesMap.transferApi;
    } 
   else if (url.startsWith("~")) {
      url = url.replace("~", "");
      this.config.baseURL = siteUrl_wapi ? siteUrl_wapi : routesMap.base;
    } else {
      this.config.baseURL = siteUrl;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url, this.config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          this.error = true;
          if (error.response.status == 401) {
            window.location = "/";
          }
          reject(error);
        })
        .then(() => {
          this.loading = false;
        });
    });
  }
  setAuth() {
    this.config.headers.Authorization =
      "Bearer " + sessionHelper.getUser().token;
  }
  postData(url, dataToSend) {
    this.setOnlineTime(1801);
    //document.body.className += ' page-loading';
    url = url;
    if(url.startsWith("~strategy")){
      url = url.replace("~strategy", "");
      this.config.baseURL = routesMap.strategyApi;
    } else if(url.startsWith("~transfer")){
      url = url.replace("~transfer", "");
      this.config.baseURL = routesMap.transferApi;
    } 
   else if (url.startsWith("~")) {
      url = url.replace("~", "");
      this.config.baseURL = siteUrl_wapi ? siteUrl_wapi : routesMap.base;
    } else {
      this.config.baseURL = siteUrl ? siteUrl : routesMap.BaseUrlWithoutApi;
    }
    url = this.config.baseURL + url;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: url,
        headers: this.config.headers,
        data: dataToSend,
      })
        .then((response) => {
          //document.body.className = document.body.className.replace(" page-loading","");
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            window.location = "/";
          }
          reject(error);
        });
    });
  }
  UploadFile(file) {
    var url = siteUrl + "upload";
    let formData = new FormData();
    formData.append("file", file);
    return new Promise((resolve, reject) => {
      axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionHelper.getUser().token,
          },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            window.location = "/";
          }
          reject(error);
        });
    });
  }
  getImage(conf) {
    return this.getData("~" + routesMap.file + conf)
      .then((ImageUrl) => {
        return ImageUrl;
      })
      .catch((err) => {
        return "";
      });
  }
  async getFileUrl(fileId) {
    const res = await httpHelper.getImage(fileId);
    if (res.result?.url) window.open(res.result.url, "_blank");
  }
}
const httpHelper = new HttpHelper();
export default httpHelper;
